import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import FileUploadActions from 'actions/files/FileUploadActions';
import FileUploadStore from 'stores/files/FileUploadStore';
import CallSharingDialog from 'components/pure/sharing/CallSharingDialog';
import AccountStore from 'stores/AccountStore';
import SharingFormActions from 'actions/sharing/SharingFormActions';
import FileUploadSharingStore from 'stores/sharing/FileUploadSharingStore';
import AccountActions from 'actions/AccountActions';
import FileUploadSharingDialogFormStore from 'stores/sharing/FileUploadSharingDialogFormStore';
import UserStore from 'stores/UserStore';
import anyTargetMayHaveSlack from 'stores/sharing/anyTargetMayHaveSlack';

@connectToStores
export default class InboxCallSharingDialogContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
  }

  static getStores() {
    return [
      FileUploadStore,
      FileUploadSharingStore,
      AccountStore,
      UserStore,
      FileUploadSharingDialogFormStore,
    ];
  }

  static getPropsFromStores() {
    const fileUploadStore = FileUploadStore.getState();
    const {hasSlack, hasSlackLoaded} = AccountStore.getState();
    const targetsMightHaveSlack = anyTargetMayHaveSlack();

    return {
      isSharingFileUploadLoading: fileUploadStore.isSearching,
      fileUploadsMap: fileUploadStore.fileUploadsMap,
      hasSlack,
      hasSlackLoaded,
      targetsMightHaveSlack,
    };
  }

  componentDidMount() {
    AccountActions.hasSlack();
    const fileUpload = FileUploadStore.getState().fileUploadsMap.get(this.props.fileUploadId);
    if (!fileUpload) {
      FileUploadActions.findFilesById([this.props.fileUploadId]);
    }
  }

  onClose() {
    this.props.onRequestClose();
    SharingFormActions.reset();
  }

  render() {
    const fileUpload = this.props.fileUploadsMap.get(this.props.fileUploadId);
    return <CallSharingDialog {...this.props} onClose={this.onClose} fileUpload={fileUpload} />;
  }
}
